import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

// Event names for App Launcher tracking
const APP_LAUNCHER_EVENT_NAMES = {
  LAUNCH_APPLICATION: 'launch_application',
  OPEN_DROPDOWN: 'open_dropdown',
  CLOSE_DROPDOWN: 'close_dropdown',
  DATA_SHARE_CONFIRM: 'data_share_confirm',
  DATA_SHARE_CANCEL: 'data_share_cancel',
};

/**
 * Tracks when an application is launched from the App Launcher
 * @param {Object} params - The parameters for tracking application launch
 * @param {Object} params.app - The application object
 * @param {string} params.source - The source of the launch (e.g., 'dropdown', 'toolbar')
 */
export const trackApplicationLaunch = ({ app, source }) => {
  gspx.trackEvent({
    name: APP_LAUNCHER_EVENT_NAMES.LAUNCH_APPLICATION,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.APP_LAUNCHER,
    capability: GPX_CAPABILITIES.APP_LAUNCHER,
    route: GPX_ROUTES.TOOLS,
    entities: {
      app_name: app.name,
      app_type: app.type,
      launch_source: source,
    },
  });
};

/**
 * Tracks data share confirmation
 * @param {Object} params - The parameters for tracking data share confirmation
 * @param {Object} params.app - The application object
 * @param {Array} [params.dataFields] - The data fields being shared
 */
export const trackDataShareConfirm = ({ app, dataFields = [] }) => {
  gspx.trackEvent({
    name: APP_LAUNCHER_EVENT_NAMES.DATA_SHARE_CONFIRM,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.APP_LAUNCHER,
    capability: GPX_CAPABILITIES.APP_LAUNCHER,
    route: GPX_ROUTES.TOOLS,
    entities: {
      app_name: app.name,
      data_fields: dataFields.join(','),
    },
  });
};

/**
 * Tracks data share cancellation
 * @param {Object} params - The parameters for tracking data share cancellation
 * @param {Object} params.app - The application object
 */
export const trackDataShareCancel = ({ app }) => {
  gspx.trackEvent({
    name: APP_LAUNCHER_EVENT_NAMES.DATA_SHARE_CANCEL,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.APP_LAUNCHER,
    capability: GPX_CAPABILITIES.APP_LAUNCHER,
    route: GPX_ROUTES.TOOLS,
    entities: {
      app_name: app.name,
    },
  });
};

/**
 * Tracks dropdown interactions
 * @param {Object} params - The parameters for tracking dropdown interactions
 * @param {string} params.action - The action (e.g., 'open', 'close')
 */
export const trackDropdownInteraction = ({ action }) => {
  const eventName =
    action === 'open'
      ? APP_LAUNCHER_EVENT_NAMES.OPEN_DROPDOWN
      : APP_LAUNCHER_EVENT_NAMES.CLOSE_DROPDOWN;

  gspx.trackEvent({
    name: eventName,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.APP_LAUNCHER,
    capability: GPX_CAPABILITIES.APP_LAUNCHER,
    route: GPX_ROUTES.TOOLS,
  });
};
